module.exports = __webpack_public_path__ + "static/media/552.3071ca92.webp";